const setImageSrc = (element) => {
  const dataSrc = element.getAttribute('data-src');
  if (dataSrc) {
    element.setAttribute('src', dataSrc);
    element.removeAttribute('data-src');
  }
};

// Lazily load images
new ScrollOut({
  targets: '[data-lazy]',
  once: true,
  onShown: (element, ctx, scrollingElement) => {
    const sources = element.querySelectorAll('source');
    const images = element.querySelectorAll('img');

    sources.forEach((source) => {
      const srcSet = source.getAttribute('data-srcset');

      if (srcSet) {
        source.setAttribute('srcset', srcSet);
        source.removeAttribute('data-srcset');
      }
    });

    images.forEach(setImageSrc);

    // or if the element itself is an image
    if (element.tagName === 'IMG') {
      setImageSrc(element);
    }
  }
});
